import { yupResolver } from '@hookform/resolvers/yup';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import InputCadastro from '../../../components/form/InputCadastro';
import InputToken from '../../../components/form/InputToken';
import useFetch from '../../../components/hooks/useFetch';
import { abreAlertaDialog } from '../../../components/modal/AlertaDialog';
import { getIPAddress } from '../../../components/utils/GetIPAddress';
import {
  ALTERAR_EMAIL,
  ENVIAR_TOKEN_PARA_TELEFONE,
  ENVIAR_TOKEN_PARA_EMAIL,
} from '../../../services/meuCorreios';
import { createFormSchemas } from './FormSchema';

function FormAlterarEmail({
  acaoCancelar,
  acaoFechar,
  dados,
  dadosDependente,
}) {
  const { t } = useTranslation();
  const { formSchemaEmail } = createFormSchemas(t);
  const methods = useForm({ resolver: yupResolver(formSchemaEmail) });
  const [ipAddress, setIpAddress] = useState('');
  useEffect(() => {
    const fetchIPAddress = async () => {
      const ip = await getIPAddress();
      const port = window.location.port;
      setIpAddress(ip + ':' + port);
    };
    fetchIPAddress();
  }, []);
  useEffect(() => {
    handleReset();
  }, [dados, dadosDependente]);
  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };

  const [modalAbertoEmail, setModalAbertoEmail] = React.useState(true);
  const [modalAbertoToken, setModalAbertoToken] = React.useState(false);
  const [modalMensagemEmail, setModalMensagemEmail] = React.useState(false);
  const openModalToken = () => {
    setModalAbertoEmail(false);
    setModalAbertoToken(true);
    setModalMensagemEmail(false);
  };
  const openModalTokenEmail = () => {
    setModalAbertoEmail(false);
    setModalAbertoToken(true);
    setModalMensagemEmail(true);
  };
  const { request } = useFetch();
  const [emailTela, setEmailTela] = React.useState();
  const [emailEnviarToken, setEmailEnviarToken] = React.useState();

  const formatarTelefoneMascarado = (telefone) => {
    const telefoneNumerico = (telefone || '').toString().replace(/\D/g, '');
    if (!telefoneNumerico) {
      return '';
    }
    return `${telefoneNumerico.charAt(0)}***${telefoneNumerico.slice(-3)}`;
  };

  const formatarEmailMascarado = (email) => {
    const emailTexto = (email || '').toString().trim();
    if (!emailTexto) {
      return '';
    }
    const [usuario, dominio] = emailTexto.split('@');
    if (!dominio) {
      return `${emailTexto.slice(0, 2)}***`;
    }
    const sufixoUsuario =
      usuario.length <= 4 ? usuario.slice(-1) : usuario.slice(-2);

    return `${(usuario || '').slice(0, 2)}***${sufixoUsuario}@${dominio}`;
  };

  const handleSubmit = async (data) => {
    var alterou = false;
    if (dadosDependente) {
      if (dadosDependente.email != data.email) {
        alterou = true;
      }
    } else {
      if (dados.email != data.email) {
        alterou = true;
      }
    }
    if (alterou) {
      setEmailTela(data.email);
      var email;
      var usuario;
      if (dadosDependente) {
        email = dados.email;
        setEmailEnviarToken(email);
        usuario = dados.idCorreios;
      } else {
        email = data.email;
        setEmailEnviarToken(email);
        usuario = dados.idCorreios;
      }

      if (dados.ddiMovel == undefined ||
        dados.ddiMovel == null || 
        dados.ddiMovel == '' ||
        dados.ddiMovel == '55') {
      
        const token = {
          meioEnvio: 'C',
          funcionalidade: 'ALTERAR_EMAIL',
          ddd: dados.dddMovel,
          telefone: dados.foneMovel?.replace(/[\(\)\-\s]/g, ''),
        };
        if (dadosDependente) {
          Object.assign(token, { dependente: dadosDependente.idCorreios });
        }
        
        const { response } = await request(
          ENVIAR_TOKEN_PARA_TELEFONE(usuario, token, ipAddress),
        );
        if (response.ok) {
          abreAlertaDialog(t('principal.messages.success.token_sent_phone'));
          openModalToken();
        }
      }else{
        const token = {
          meioEnvio: 'E',
          funcionalidade: 'ALTERAR_TELEFONE',
          email: data.email,
        };
        if (dadosDependente) {
          Object.assign(token, { dependente: dadosDependente.idCorreios });
        }
        const { response } = await request(
          ENVIAR_TOKEN_PARA_EMAIL(usuario, token, ipAddress),
        );
        if (response.ok) {
          abreAlertaDialog(t('principal.messages.success.token_sent_email'));
          openModalTokenEmail();
        }
      }
    } else {
      abreAlertaDialog(t('principal.messages.success.email_not_changed'));
    }
  };
  const alterar = async () => {
    const token =
      document.getElementById('confirmarSenha1').value +
      document.getElementById('confirmarSenha2').value +
      document.getElementById('confirmarSenha3').value +
      document.getElementById('confirmarSenha4').value +
      document.getElementById('confirmarSenha5').value +
      document.getElementById('confirmarSenha6').value;
    if (token.length < 6) {
      abreAlertaDialog(
        t('principal.messages.validation.token_digits_required'),
      );
    } else {
      const emailEnviar = {
        email: emailTela,
      };
      var usuario;
      if (dadosDependente) {
        usuario = dadosDependente.idCorreios;
      } else {
        usuario = dados.idCorreios;
      }
      const { response } = await request(
        ALTERAR_EMAIL(dados.idCorreios, usuario, token, emailEnviar, ipAddress),
      );

      if (response.ok) {
        abreAlertaDialog(t('principal.messages.success.email_changed'));
        setModalAbertoEmail(true);
        setModalAbertoToken(false);
        acaoFechar();
      }
    }
  };

  const reenviaToken = async () => {
    const token = {
      meioEnvio: 'C',
      funcionalidade: 'ALTERAR_EMAIL',
      ddd: dados.dddMovel,
      telefone: dados.foneMovel?.replace(/[\(\)\-\s]/g, ''),
    };
    if (dadosDependente) {
      Object.assign(token, { dependente: dadosDependente.idCorreios });
    }
    const { response } = await request(
      ENVIAR_TOKEN_PARA_TELEFONE(dados.idCorreios, token, ipAddress),
    );
    if (response.ok) {
      abreAlertaDialog(t('principal.messages.success.token_sent'));
    }
  };

  const reenviaTokenEmail = async () => {
    const token = {
      meioEnvio: 'E',
      funcionalidade: 'ALTERAR_TELEFONE',
      email: emailTela,
    };
    if (dadosDependente) {
      Object.assign(token, { dependente: dadosDependente.idCorreios });
    }
    const { response } = await request(
      ENVIAR_TOKEN_PARA_EMAIL(dados.idCorreios, token, ipAddress),
    );
    if (response.ok) {
      abreAlertaDialog(t('principal.messages.success.token_sent_email'));
    }
  };

  const fechar = (ev) => {
    ev.preventDefault();
    setModalAbertoEmail(true);
    setModalAbertoToken(false);
    handleReset();
    acaoCancelar();
  };
  const fecharToken = (ev) => {
    ev.preventDefault();
    setModalAbertoEmail(true);
    setModalAbertoToken(false);
    acaoCancelar();
  };
  const handleReset = () => {
    const form = document.getElementById('formEmail');
    const emailInput = form.querySelector('#email');
    emailInput.value = dadosDependente?.email || dados?.email;
  };
  return (
    <>
      {modalAbertoEmail && (
        <form id="formEmail" onSubmit={methods.handleSubmit(handleSubmit)}>
          <div className="dialog-main" id="dialog-main-email">
            <div className="campos">
              <InputCadastro
                id="email"
                name="email"
                label={t('principal.forms.labels.email')}
                placeholder=""
                maxLength="80"
                defaultValue={dadosDependente?.email || dados?.email}
                {...formMethods}
              />
            </div>
            <div className="mensagem legenda"></div>
          </div>

          <div className="dialog-footer">
            <button className="btn-txt btn-fecha-dialog" onClick={fechar}>
              {t('principal.forms.buttons.cancel')}
            </button>
            <button className="btn-pre" id="btn-email" type="submit">
              {t('principal.forms.buttons.change')}
            </button>
          </div>
        </form>
      )}
      {modalAbertoToken && (
        <form id="formToken">
          <div
            id="finaliza-cadastro"
            className="conteudo"
            style={{ padding: '0.5rem 0.25rem' }}
          >
            <div id="bem-vindo" className="card bg-superficie elev5">
              <img
                alt="Imagem de perfil da Carol"
                id="img-carol-boasvindas"
                src="/images/carol-perfil.png"
              />

              <h2>{t('principal.forms.titles.finalize_change')}</h2>

              {!modalMensagemEmail && (
                <p className="txt-finalizacao">
                  {t('principal.forms.messages.finalize_phone_change', {
                    telefone: formatarTelefoneMascarado(dados?.foneMovel),
                  })}
                </p>
              )}
              {modalMensagemEmail && (
                <p className="txt-finalizacao">
                  {t('principal.forms.messages.finalize_email_change', {
                    email: formatarEmailMascarado(emailTela),
                  })}
                </p>
              )}
              <div className="campo-txt">
                <InputToken />
              </div>
              <p
                className="txt-finalizacao"
                style={{ fontSize: '0.8rem', lineHeight: '1.3' }}
              >
                Caso tenha perdido acesso ao telefone informado no cadastro, abra uma manifestação no&nbsp;
                <a href="https://faleconosco.correios.com.br/faleconosco/app/cadastro/suporte/tecnologico-mc/index.php" target="_blank" rel="noopener noreferrer">
                  Fale Conosco.
                </a> 
                Solicite a atualização do telefone no cadastro Meu Correios, 
                encaminhando telefone atual, RG do representante legal, Ato da constituição da empresa e procuração legal, se houver.
              </p>
              <div className="btns-row" style={{ gap: '0.7rem', marginTop: '0.1rem' }}>
                {!modalMensagemEmail && (
                  <button
                    id="btn-reenviar"
                    type="button"
                    className="btn-cont"
                    onClick={reenviaToken}
                  >
                    {t('principal.forms.buttons.resend_code')}
                  </button>
                )}
                {modalMensagemEmail && (
                  <button
                    id="btn-reenviar"
                    type="button"
                    className="btn-cont"
                    onClick={reenviaTokenEmail}
                  >
                    {t('principal.forms.buttons.resend_code')}
                  </button>
                )}
                <button
                  id="btn-finalizar"
                  type="button"
                  className="btn-pre"
                  onClick={alterar}
                >
                  {t('principal.forms.buttons.finalize')}
                </button>
                <button
                  className="btn-txt btn-fecha-dialog"
                  onClick={fecharToken}
                >
                  {t('principal.forms.buttons.cancel')}
                </button>
              </div>
            </div>
          </div>
        </form>
      )}
    </>
  );
}
export default FormAlterarEmail;
